export class UserUnauthorizedError extends Error {
    constructor() {
        super('User unauthorized.');
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, UserUnauthorizedError);
        }
        this.name = 'UserProfileUnauthorizedError';
    }
}
